/**
 * nh-read-more.js — <nh-read-more> (snippets/nh-read-more.liquid).
 * Folds the text to N lines (data-lines) and shows the toggle only when the text is longer.
 * The toggle unfolds the same text in place and folds it back. Re-measures on resize.
 */
(function () {
  if (!window.customElements || customElements.get('nh-read-more')) return;

  class NhReadMore extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.nh-rm__text');
      this.btn = this.querySelector('.nh-rm__toggle');
      if (!this.text || !this.btn) return;
      this.lines = Number(this.dataset.lines) || 3;
      this.setAttribute('data-ready', '');
      this.btn.addEventListener('click', () => this.toggle());
      this.measure();
      if (window.ResizeObserver) {
        let width = this.offsetWidth;
        this.ro = new ResizeObserver(() => {
          if (this.offsetWidth === width) return;
          width = this.offsetWidth;
          if (!this.classList.contains('is-open')) this.measure();
        });
        this.ro.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    foldedHeight() {
      const style = getComputedStyle(this.text);
      let lh = parseFloat(style.lineHeight);
      if (!lh) lh = parseFloat(style.fontSize) * 1.5 || 24;
      return Math.round(lh * this.lines);
    }

    measure() {
      const folded = this.foldedHeight();
      this.text.style.maxHeight = 'none';
      const long = this.text.scrollHeight > folded + 4;
      this.classList.toggle('is-clamped', long);
      this.btn.hidden = !long;
      this.text.style.maxHeight = long ? `${folded}px` : 'none';
    }

    toggle() {
      const open = !this.classList.contains('is-open');
      this.classList.toggle('is-open', open);
      this.btn.setAttribute('aria-expanded', String(open));
      this.btn.querySelector('span').textContent = open ? this.btn.dataset.less : this.btn.dataset.more;
      if (open) {
        this.text.style.maxHeight = `${this.text.scrollHeight}px`;
        const done = () => { if (this.classList.contains('is-open')) this.text.style.maxHeight = 'none'; };
        this.text.addEventListener('transitionend', done, { once: true });
        setTimeout(done, 450);
      } else {
        this.text.style.maxHeight = `${this.text.scrollHeight}px`;
        requestAnimationFrame(() => requestAnimationFrame(() => { this.text.style.maxHeight = `${this.foldedHeight()}px`; }));
      }
    }
  }

  customElements.define('nh-read-more', NhReadMore);
})();
